import _ from 'lodash';
import * as actions from '../actions/company';
import { abridgeJobs } from '../selectors/company/jobs';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_JOBS_HOME_PAGE: {
      return Object.assign({}, state, {
        jobsHomePage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_JOBS: {
      return Object.assign({}, state, {
        jobs: abridgeJobs(_.get(action, 'result')),
      });
    }
    case actions.SET_JOB_DESCRIPTION_PAGE: {
      return Object.assign({}, state, {
        jobDescriptionPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_JOB_DESCRIPTION_CALL_TO_ACTION: {
      return Object.assign({}, state, {
        callToAction: _.get(action, 'result.fields.text'),
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/company.js